import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { PurchaseHistoryItemDto } from '../dtos';

@Injectable()
export class PurchaseHistoryService {
  private path = 'transaction/summary';
  constructor(private httpService: HttpService) {}

  public getPurchaseHistory(): Observable<Array<PurchaseHistoryItemDto>> {
    return this.httpService.makeGet<Array<PurchaseHistoryItemDto>>(`${this.path}`);
  }
}
